import { notification } from "antd";

export default function handleApiError(error: any) {
  notification.error({
    message: "Error",
    description: error?.response?.data?.status || error?.message,
  });
}
